import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { CompanyEntity, EMPTY_COMPANY_ENTITY } from "domain/entity/Company/CompanyEntity";
import { EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY, RecalProposalSetDtlEntity } from "domain/entity/RecalProposalSet/RecalProposalSetDtlEntity";
import { EMPTY_RECAL_PROPOSAL_SET_ENTITY, RecalProposalSetEntity, } from "domain/entity/RecalProposalSet/RecalProposalSetEntity";
import { TariffRecalProposalEntity } from "domain/entity/RecalProposalSet/TariffRecalProposalEntity";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { RecalProposalSetRepository } from "domain/repository/RecalProposalSet/RecalProposalSetRepo";
import _ from "lodash";
import { rcTypeDropdownOption, statusDropdownOptions } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { createRecalProposalSetDtlValidationSchema, createRecalProposalSetValidationSchema } from "presentation/constant/RecalProposalSet/RecalProposalSetValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { DropdownProps } from "presentation/model/DropdownProps";
import { RecalProposalSetModel } from "presentation/model/RecalProposalSet/RecalProposalSetModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface RecalProposalSetVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<RecalProposalSetModel>> | ((value: SetStateAction<RecalProposalSetModel>) => void),
    ],
    recalProposalSetRepo: RecalProposalSetRepository,
    companyRepo: CompanyRepository,
}

export const RecalProposalSetVM = ({ dispatch, recalProposalSetRepo, companyRepo
}: RecalProposalSetVMProps) => {
    const [recalProposalSetDispatch] = dispatch;

    const loadDropdownOption = async () => {

        await companyRepo.getAllCompanyForCombobox().then(
            companies => {
                let companyCodeDropdownOption = companies?.filter(company => company.companyType !== "MASTER" && company.companyType !== "ALLIANCE")
                    .map((company) => ({
                        dropdownLabel: company.companyCode,
                        tagLabel: company.companyCode,
                        value: company.companyCode,
                    }
                    )) ?? []
                companyCodeDropdownOption = _.orderBy(companyCodeDropdownOption, "dropdownLabel");

                let companyList: { [key: string]: CompanyEntity[] } = {};
                companies?.filter(company => company.companyType !== "MASTER" && company.companyType !== "ALLIANCE").forEach(
                    company => {
                        if (!companyList[company.companyCode]) {
                            companyList[company.companyCode] = []
                        }
                        companyList[company.companyCode].push({ ...EMPTY_COMPANY_ENTITY, ...company });
                    }
                )

                recalProposalSetDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        companyCodeDropdownOptions: companyCodeDropdownOption,
                    },
                    companyList: companyList,
                }))
            }
        )

        await recalProposalSetRepo.searchRecalProposalSetCombox().then(
            proposal => {
                let proposalNoDropdownOptions: { [key: string]: DropdownProps[] } = {};
                let proposalList: { [key: string]: TariffRecalProposalEntity[] } = {};
                proposal.forEach(proposal => {
                    if (proposal.companyId) {
                        if (!proposalNoDropdownOptions[proposal.companyId]) {
                            proposalNoDropdownOptions[proposal.companyId] = [];
                        }
                        proposalNoDropdownOptions[proposal.companyId].push({
                            dropdownLabel: proposal.proposalNo ?? '',
                            tagLabel: proposal.proposalNo ?? '',
                            value: proposal.proposalNo ?? '',
                        });
                        if (!proposalList[proposal.companyId]) {
                            proposalList[proposal.companyId] = [];
                        }
                        proposalList[proposal.companyId].push(proposal);
                    }
                })
                recalProposalSetDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        proposalNoDropdownOptions: proposalNoDropdownOptions,
                    },
                    proposalList: proposalList,
                }))
            }
        )

    }

    const searchAllRecalProposalSetList = async () => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                currentRow: { ...EMPTY_RECAL_PROPOSAL_SET_ENTITY },
                currentEditRow: { ...EMPTY_RECAL_PROPOSAL_SET_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                updatedRows: [],
                recalProposalSetList: [],
                currentDtlEditRow: { ...EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY },
                tempDtlRows: [],
            }
        })
        await recalProposalSetRepo.searchAllRecalProposalSetList().then(data => {
            if (data) {
                recalProposalSetDispatch(prevState => {
                    return {
                        ...prevState,
                        recalProposalSetList: data,
                    }
                })
            } else {
                recalProposalSetDispatch(prevState => {
                    return {
                        ...prevState,
                        recalProposalSetList: [],
                    }
                })
            }
        })
    }

    const updateSelectedRows = async (rows: RecalProposalSetEntity[]) => {

        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                // recalProposalSetList: [...allRows],
                selectedRows: rows,
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const updateSelectedDtlRows = async (updatedRows: RecalProposalSetDtlEntity[]) => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                selectedDtlRows: updatedRows,
                // currentDtlEditRow: updatedRows.length === 1 ? updatedRows[0] : { ...EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY },
                dtlForceRefresh: !prevState.dtlForceRefresh
            }
        })
    }

    const onHeaderFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        if (fieldKey === 'proposalSetDesc' && val) {
            val = val.length > 180 ? val.substring(0, 180) : val;
        }
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onDtlFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        recalProposalSetDispatch(prevState => {
            let companyType = prevState.currentDtlEditRow.companyType;
            let createdBy = prevState.currentDtlEditRow.createdBy;
            let createdDateTime = prevState.currentDtlEditRow.createdDateTime;
            let expiryDate = prevState.currentDtlEditRow.expiryDate;
            let effectiveDate = prevState.currentDtlEditRow.effectiveDate;
            let proposalNo = prevState.currentDtlEditRow.proposalNo;
            let proposalId = prevState.currentDtlEditRow.proposalId;

            if (fieldKey === 'companyCode') {
                if (prevState.companyList[val]) {
                    companyType = prevState.companyList[val][0]?.companyType;
                }
                createdBy = null;
                createdDateTime = null;
                expiryDate = null;
                effectiveDate = null;
                proposalNo = null;

            }
            if (fieldKey === 'proposalNo') {
                const companyId = prevState.companyList[prevState.currentDtlEditRow.companyCode ?? ''][0]?.id;
                proposalNo = val;
                let proposalList = prevState.proposalList[companyId]?.filter(a => a.proposalNo === proposalNo);
                createdBy = proposalList[0]?.createdBy;
                createdDateTime = proposalList[0]?.createdDateTime;
                expiryDate = proposalList[0]?.expiryDate;
                effectiveDate = proposalList[0]?.effectiveDate;
                proposalId = proposalList[0]?.id;
            }
            return {
                ...prevState,
                currentDtlEditRow: {
                    ...prevState.currentDtlEditRow,
                    [fieldKey]: val,
                    companyType: companyType,
                    createdBy: createdBy,
                    createdDateTime: createdDateTime,
                    expiryDate: expiryDate,
                    effectiveDate: effectiveDate,
                    proposalNo: proposalNo,
                    proposalId: proposalId,

                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onRowDoubleClick = async (entity: RecalProposalSetEntity) => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                // currentEditRow: entity,
                currentRow: entity,
                tempDtlRows: entity.recalProposalSetDtlList ?? [],
                isShowEditPanel: true,
            }
        })
    }

    const onDtlRowDoubleClick = async (entity: RecalProposalSetDtlEntity) => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: entity,
                isShowDtlEditPanel: true,
                isShowDtlAddPanel: false,
            }
        })
    }

    const onDtlDtlDeleteClick = async (entitys: RecalProposalSetDtlEntity[]) => {
        recalProposalSetDispatch(prevState => {
            let dtls = prevState.tempDtlRows?.slice();
            const newDtls = dtls.filter(a => !entitys?.some(b => {
                if (!b.id) {
                    return b.tempKey === a.tempKey;
                } else {
                    return b.id === a.id;
                }
            }));
            return {
                ...prevState,
                selectedDtlRows: [],
                currentEditRow: {
                    ...prevState.currentEditRow,
                    recalProposalSetDtlList: newDtls,
                },
                tempDtlRows: newDtls,
                dtlForceRefresh: !prevState.dtlForceRefresh
            }
        })
    }

    const onDelete = async (entitys: RecalProposalSetEntity[]) => {
        return recalProposalSetRepo.deleteEntity(entitys);
    }

    const onDtlAddRowClick = async (operatingUnit?: string) => {
        recalProposalSetDispatch(prevState => {
            const companyCode = prevState.dynamicOptions?.companyCodeDropdownOptions?.sort((a, b) => a?.dropdownLabel!.localeCompare(b?.dropdownLabel!))?.[0]?.value ?? '';
            const companyId = prevState.companyList?.[companyCode][0]?.id;
            const proposalNo = prevState.dynamicOptions?.proposalNoDropdownOptions?.[companyId]?.sort((a, b) => a?.dropdownLabel!.localeCompare(b?.dropdownLabel!))?.[0]?.value ?? '';
            const companyType = companyCode ? prevState.companyList[companyCode][0]?.companyType : "";
            let proposalList = prevState.proposalList[companyId]?.filter(a => a.proposalNo === proposalNo);
            const createdBy = proposalList && proposalList[0]?.createdBy;
            const createdDateTime = proposalList && proposalList[0]?.createdDateTime;
            const expiryDate = proposalList && proposalList[0]?.expiryDate;
            const effectiveDate = proposalList && proposalList[0]?.effectiveDate;
            const proposalId = proposalList && proposalList[0]?.id;
            return {
                ...prevState,
                currentDtlEditRow: (operatingUnit === 'OICT' || operatingUnit === 'HPJZ') ?
                    {
                        ...EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY,
                        tempKey: _.uniqueId(),
                        cntrStatus: statusDropdownOptions[0]?.value ?? '',
                        companyCode: companyCode,
                        proposalNo: prevState.dynamicOptions?.proposalNoDropdownOptions?.[companyId]?.sort((a, b) => a?.dropdownLabel!.localeCompare(b?.dropdownLabel!))?.[0]?.value ?? '',
                        companyType: companyType,
                        createdBy: createdBy,
                        createdDateTime: createdDateTime,
                        expiryDate: expiryDate,
                        effectiveDate: effectiveDate,
                        proposalId: proposalId
                    } :
                    {
                        ...EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY,
                        tempKey: _.uniqueId(),
                        cntrStatus: statusDropdownOptions[0]?.value ?? '',
                        //movementCode: prevState.dynamicOptions.moveIndDropdownOptions.length > 0 ? prevState.dynamicOptions.moveIndDropdownOptions[0].value : ''
                    },
                isShowDtlAddPanel: true,
                isShowDtlEditPanel: false,
            }
        })
    }

    const onCloseEidtPanel = async () => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: { ...EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY },
                tempDtlRows: [],
                currentEditRow: { ...EMPTY_RECAL_PROPOSAL_SET_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        })
    }

    const onCloseDtlEidtPanel = async () => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: { ...EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY },
                isShowDtlAddPanel: false,
                isShowDtlEditPanel: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        })
    }

    const onSave = async (currentRow: RecalProposalSetEntity) => {

        const valResult = await Validation(createRecalProposalSetValidationSchema).ValidateFormOnly(currentRow);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            recalProposalSetDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }

        return recalProposalSetRepo.onSave(currentRow);
    }

    const onSaveClicked = () => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    const onAddClick = async () => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...EMPTY_RECAL_PROPOSAL_SET_ENTITY,
                    patternType: rcTypeDropdownOption[0]?.value ?? ''
                },
                isShowEditPanel: true,
                isAdd: true,
            }
        })
    }

    const onDtlTempSave = async (dtlEditRow: RecalProposalSetDtlEntity) => {
        const valResult = await Validation(createRecalProposalSetDtlValidationSchema).ValidateFormOnly(dtlEditRow);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            recalProposalSetDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
            return;
        }
        recalProposalSetDispatch(prevState => {
            let newDtls = prevState.tempDtlRows?.slice();
            let existingDtlIndex = newDtls?.findIndex(dtl => {
                if (dtl.id) {
                    return dtl.id === dtlEditRow.id
                } else {
                    return dtl.tempKey === dtlEditRow.tempKey
                }

            });
            if (existingDtlIndex !== -1) {
                Object.assign(newDtls[existingDtlIndex], dtlEditRow);
            } else {
                newDtls.push(dtlEditRow);
            }
            return {
                ...prevState,
                tempDtlRows: newDtls,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    recalProposalSetDtlList: newDtls,
                },
                currentDtlEditRow: { ...EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY },
                isShowDtlEditPanel: false,
                isShowDtlAddPanel: false,
                dtlForceRefresh: !prevState.dtlForceRefresh
            }
        })
    }
    const onResetClick = async (isAdd: boolean) => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: isAdd ? { ...EMPTY_RECAL_PROPOSAL_SET_ENTITY } : prevState.currentRow,
                tempDtlRows: isAdd ? [] : prevState.currentRow.recalProposalSetDtlList ?? [],
                isShowDtlEditPanel: false,
                isShowDtlAddPanel: false,
                currentDtlEditRow: { ...EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY },
            }
        })
    }
    const onEditClick = async () => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                isEdit: true,
                currentEditRow: prevState.currentRow,
            }
        })
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }
    const onDtlCheckboxChange = (checked: boolean, fieldName: string) => {
        recalProposalSetDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: {
                    ...prevState.currentDtlEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }

    return {
        onDtlCheckboxChange: onDtlCheckboxChange,
        onResetClick: onResetClick,
        onCheckboxChange: onCheckboxChange,
        onDtlDtlDeleteClick: onDtlDtlDeleteClick,
        onEditClick: onEditClick,
        onDtlTempSave: onDtlTempSave,
        onCloseDtlEidtPanel: onCloseDtlEidtPanel,
        onDtlAddRowClick: onDtlAddRowClick,
        onDtlRowDoubleClick: onDtlRowDoubleClick,
        onDtlFieldChange: onDtlFieldChange,
        onAddClick: onAddClick,
        onSave: onSave,
        onCloseEidtPanel: onCloseEidtPanel,
        onRowDoubleClick: onRowDoubleClick,
        onHeaderFieldChange: onHeaderFieldChange,
        updateSelectedRows: updateSelectedRows,
        updateSelectedDtlRows: updateSelectedDtlRows,
        loadDropdownOption: loadDropdownOption,
        searchAllRecalProposalSetList: searchAllRecalProposalSetList,
        onSaveClicked: onSaveClicked,
        onDelete: onDelete,
    }
}